jQuery('#projectorOnRightContent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true,
    appendDots: jQuery('#projectorOnRightContentDots'),
});

jQuery('.staggered-content-projector-on-right .hotspot').click(function() {
    switch (jQuery('.staggered-content-projector-on-right .image-container').attr('data-status')) {
        case 'open':
            jQuery('.staggered-content-projector-on-right .image-container').attr('data-status', 'closed');
            
            jQuery('.staggered-content-projector-on-right .video-closing').show();
            document.getElementById('projectorClosing').play();

            jQuery('.staggered-content-projector-on-right .video-opening').hide();
            jQuery('.staggered-content-projector-on-right .img-open').hide();
            break;
        case 'closed':
            jQuery('.staggered-content-projector-on-right .image-container').attr('data-status', 'open');
            
            jQuery('.staggered-content-projector-on-right .video-opening').show();
            document.getElementById('projectorOpening').play();

            jQuery('.staggered-content-projector-on-right .video-closing').hide();
            jQuery('.staggered-content-projector-on-right .img-closed').hide();
            break;
    }
});